import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { environment } from '../../environments/environment';

export type Duelist = {
	_id?: string;
	username: string;
};

@Injectable({
	providedIn: 'root',
})
export class DuelistsService {
	private restServerUrl: string;
	duelists = new BehaviorSubject<Duelist[]>([]);
	duelists$ = this.duelists.asObservable();
	private _selectedDuelist = new BehaviorSubject<Duelist | null>(null);
	selectedDuelist$ = this._selectedDuelist.asObservable();

	constructor(private http: HttpClient) {
		const protocol = environment.ssl ? 'https://' : 'http://';
		this.restServerUrl = protocol + environment.restServer + ':' + environment.restServerPort;
	}

	/**
	 * Set the currently selected duelist for challenging. This is used to pass the selected duelist from the duelists list page to the duel create page.
	 * @param duelist The duelist that was selected, or null to reset the selection
	 */
	set selectedDuelist(duelist: Duelist | null) {
		this._selectedDuelist.next(duelist);
	}

	getDuelistsList() {
		return this.http
			.get<Duelist[]>(this.restServerUrl + '/api/user/duelist')
			.pipe(tap(duelists => this.duelists.next(duelists)));
	}

	addDuelist(duelist: Duelist) {
		this.duelists.next([...this.duelists.value, duelist]);
	}
}
